import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "./ui/separator";
import { cn } from "@/lib/utils";

const CustomTabs = ({ tabs, tabData, pos }: any) => {
  return (
    <Tabs
      defaultValue={tabs[0]}
      className={cn(pos ? pos : "flex flex-col")}
      orientation={pos ? "vertical" : "horizontal"}
    >
      <TabsList
        className={cn(
          "h-0 gap-6 p-0  bg-transparent",
          pos
            ? "flex flex-col pr-16 items-start justify-start"
            : "flex justify-start pb-3"
        )}
      >
        {tabs?.map((tab: string) => (
          <TabsTrigger
            className="data-[state=active]:bg-transparent data-[state=active]:text-primary
      data-[state=active]:border-b-primary data-[state=active]:border-b-[1.5px] data-[state=active]:shadow-none
      p-0 rounded-none pb-1
      "
            value={tab}
            key={tab}
          >
            {tab}
          </TabsTrigger>
        ))}
      </TabsList>

      <Separator orientation={pos ? "vertical" : "horizontal"} />
      {tabs?.map((tab: string) => (
        <TabsContent
          value={tab}
          key={tab}
          className={cn(pos ? "py-0" : "py-10")}
        >
          {Object.entries(tabData)?.map(
            ([key, value]) => key === tab && <div key={key}>{value}</div>
          )}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default CustomTabs;
